<template>
    <div class="feeds-view">
        <div class="left-panel">
            <img class="entity-logo" v-if="$store.getters.currentEntity" :src="$store.getters.currentEntity.logo">
            <global-informations></global-informations>
        </div>
        <div class="feeds-container">
            <div class="to-entities">
                <router-link :to="{ name: 'dashboard' }">
                    <el-button type="text" icon="el-icon-arrow-left">ENTITIES</el-button>
                </router-link>
            </div>
            <div class="header">
                <div class="title">Feeds</div>
                <div>
                    <gcmcn-filters
                        :filter-values="[universesFilter, searchFilter, eventsFilter, dateRange]"
                        @reset-filters="resetFilters"
                    >
                        <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                        <date-picker-range  ref="date-range" @on-range-selected="setDaterange"></date-picker-range>
                        <dropdown
                            name="Universes"
                            :list="universesForFilter"
                            :itemsSelected="universesFilter"
                            @on-select-item="selectedUniversesFilter"
                        ></dropdown>
                        <dropdown
                            name="Events"
                            rightAligned
                            :list="eventsForFilter"
                            :itemsSelected="eventsFilter"
                            @on-select-item="selectedEventsFilter"
                        ></dropdown>
                    </gcmcn-filters>
                </div>
            </div>
            <div>
                <div v-if="!$store.getters.modelsScopedLoaded" class="loading-models">
                    <div class="text-center">
                        <div>LOADING MODELS</div>
                        <loading-template></loading-template>
                    </div>
                </div>
                <template v-else-if="filteredFeeds.length > 0">
                    <virtual-list
                        class="feed-virtual-list"
                        :data-key="'uid'"
                        :data-sources="filteredFeeds"
                        :data-component="itemComponent"
                        :keeps="8"
                        :extimate-size="160"
                        item-class="feed-item"
                        :extra-props="{
                            otherPropValue: {
                                universes: universes,
                                events: events,
                                configurations: currentTakerConfiguration,
                                defaultPreviewImageUrl: defaultPreviewImageUrl,
                                unMutedFeedsUid: unMutedFeedsUid
                            }
                        }"
                    ></virtual-list>
                </template>
                <div v-else class="no-feed">no feeds</div>
            </div>
        </div>
    </div>
</template>

<script>

import globalInformations from './global-informations.vue';
import FeedCard from './feed-card.vue';
import {
    LoadingTemplate,
    DatePickerRange,
    Dropdown,
    SearchFilter,
    CommonFilters,
    GcmcnFilters
} from 'gcmcn-common';
import moment from 'moment';
import { mapGetters } from 'vuex';
import VirtualList from 'vue-virtual-scroll-list';
export default {
    components: {
        Dropdown,
        SearchFilter,
        globalInformations,
        DatePickerRange,
        LoadingTemplate,
        VirtualList,
        GcmcnFilters,

    },
    name: 'feeds-view',

    props: {

    },

    data (){
        return {
            searchFilter: '',
            eventsFilter: [],
            universesFilter: [],
            dateRange: '',
            itemComponent: FeedCard,
            unMutedFeedsUid: []
        };
    },
    created() {
        this.$on('toggleSound', (payload) => {
            if (payload.muted === false) {
                if (!this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.push(payload.feedUid);
                }
            } else {
                if (this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.splice(this.unMutedFeedsUid.indexOf(payload.feedUid), 1);
                }
            }
        });
    },
    computed: {
        ...mapGetters([
            'eventsByUid',
            'universesByUid',
            'configurations',
            'currentTakerConfiguration',
            'currentTaker',
            'events',
            'universes',
            'feeds',
            'broadcastRights',
        ]),
        defaultPreviewImageUrl() {
            return '../../../../static/img/no_preview.png';
        },
        eventsForFilter (){
            let filters = [];
            const map = new Map();
            for(let feed of this.feedsWithBroadcastRights){
                if(!map.has(feed.event)){
                    map.set(feed.event, true);
                    let eventName = '';
                    try{
                        eventName = this.eventsByUid(feed.event).name;
                    }catch(e){
                        eventName = 'name not found';
                    }
                    filters.push({
                        name: eventName,
                        value: feed.event,
                    });
                }
            }
            return filters;
        },
        universesForFilter (){
            let filters = [];
            const map = new Map();
            for(let event of this.eventsForFilter){
                let eventStored = this.eventsByUid(event.value);
                if(eventStored && !map.has(eventStored.universe)){
                    map.set(eventStored.universe, true);
                    let universeName = '';
                    try{
                        universeName = this.universesByUid(eventStored.universe).name;
                    }catch(e){
                        universeName = 'name not found';
                    }
                    filters.push({
                        name: universeName,
                        value: eventStored.universe,
                    });
                }
            }
            return filters;
        },
        feedsWithBroadcastRights (){
            // broadcastRights
            return this.feeds.filter(
                feed => {
                    return this.broadcastRights.find(
                        br => br.taker_uid === this.currentTaker.uid && br.feed_uid === feed.uid
                    );
                }
            );
        },

        feedsNotFinished (){
            return this.feedsWithBroadcastRights.filter((feed) => feed.status !== 'FINISHED');
        },

        feedsFinishedToDisplay (){
            // display only feeds confirmed and configured (https://git.netsach.info/globecast/gcmcn/support/-/issues/19)
            return this.feedsWithBroadcastRights.filter((feed) => {
                return feed.status === 'FINISHED' &&
                feed.confirmed === true &&
                this.configurations.find((conf) => conf.feed_uid === feed.uid) !== undefined;
            });
        },

        filteredFeeds (){
            let feeds = this.feedsNotFinished.concat(this.feedsFinishedToDisplay);
            if(this.dateRange.length > 0){
                // obbligé d'ajouter 1 jours car si le user selectionne par exemple le 30/07/2020 la valeur retournée sera 29/07/2020
                let start = moment.utc(this.dateRange[0]).set({hour: 0, minute: 0, second: 0}).add(1, 'days');
                let end = moment.utc(this.dateRange[1]).set({hour: 23, minute: 59, second: 59}).add(1, 'days');
                feeds = feeds.filter((feed) => {
                    return moment.utc(feed.start_date).isAfter(start) && moment.utc(feed.end_date).isBefore(end);
                });
            }
            if(this.eventsFilter.length > 0){
                feeds = feeds.filter((feed) => {
                    return this.eventsFilter.indexOf(feed.event) >= 0;
                });
            }
            if(this.universesFilter.length > 0){
                let feedsEvent = [...new Set(feeds.map((feed) => feed.event))];
                let eventFilteredByUniverses = [];
                for(let event of feedsEvent){
                    if(this.universesFilter.indexOf(this.eventsByUid(event).universe) >= 0){
                        eventFilteredByUniverses.push(event);
                    }
                }
                feeds = feeds.filter((feed) => {
                    return eventFilteredByUniverses.indexOf(feed.event) >= 0;
                });
            }
            if(this.searchFilter !== ''){
                let searchFilter = this.searchFilter.toLowerCase();
                feeds = feeds.filter((feed) => {
                    return feed.name.toLowerCase().includes(searchFilter) ||
                           feed.status.toLowerCase().includes(searchFilter) ||
                           this.$store.getters.eventsByUid(feed.event_uid).name.toLowerCase().includes(searchFilter);
                });
            }

            let orderedFeeds = this.runningFeeds(feeds);
            orderedFeeds.push(...this.availablesFeeds(feeds));
            orderedFeeds.push(...this.failedFeeds(feeds));
            orderedFeeds.push(...this.finishedFeeds(feeds));
            return orderedFeeds;
        },
    },

    mounted (){
    },

    methods: {
        selectedEventsFilter (val){
            this.$set(this, 'eventsFilter', val);
        },
        selectedUniversesFilter (val){
            this.$set(this, 'universesFilter', val);
        },
        setDaterange (val) {
            this.$set(this, 'dateRange', val);
        },
        runningFeeds (feeds){
            return feeds.filter((feed) => CommonFilters.filterByRunningStatus(feed)).sort((a,b)  => {
                return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
            });

        },
        availablesFeeds (feeds){
            return feeds.filter((feed) => CommonFilters.filterByAvailableFeeds(feed)).sort((a,b)  => {
                return new Date(b.confirmed ? b.confirmed_start_date : b.start_date) - new Date(a.confirmed ? a.confirmed_start_date : a.start_date);
            });
        },
        finishedFeeds (feeds){
            return feeds.filter((feed) => CommonFilters.filterByFinishedStatus(feed)).sort((a,b)  => {
                return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
            });
        },
        failedFeeds (feeds){
            return feeds.filter((feed) => CommonFilters.filterByFailedStatus(feed)).sort((a,b)  => {
                return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
            });

        },
        resetFilters (){
            this.$set(this, 'universesFilter', []);
            this.$set(this, 'eventsFilter', []);
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$refs['date-range'].clear();
        },
    },
};
</script>

<style lang="scss">
.feeds-view {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 1160px;
    margin: auto;

    .feed-item{
        margin-top: 20px;
    }
    .feed-virtual-list{
        height: calc( 100vh - 210px); // 210 px est la taille du header plus titre et filtres
        overflow: auto;
    }
    .left-panel {
        position: relative;
        margin-right: 40px;
        .entity-logo{
            width: 110px;
            height: 110px;
        }
        .global-information {
            margin-top: 120px;
        }
        img {
            position: absolute;
        }
    }
    .feeds-container {
        z-index: 1;
        color: #BBBBBB;
        font-size: 30px;
        flex-grow: 1;
        text-transform: uppercase;
        .filter-container{
            width: fit-content;
            display: flex;
            margin-bottom: 15px;
            margin-left: auto;
            & > *{
                margin-right: 25px;
            }
            & > *:last-child{
                margin-right: 0;
            }
        }
        .to-entities {
            margin-bottom: 10px;
            .el-button {
                color: #BBBBBB !important;
            }
        }
        .title {
            font-family: "Roboto Light";
            margin-bottom: 20px;
        }
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: transparent;
        }
    }
    .no-feed{
        width: 100%;
        padding: 30px 40px;
        height: 500px;
        border-radius: 5px;
        background: linear-gradient(180deg, #222222 0%, #111111 61.77%);
        font-size: 18px;
        color: #bbb;
        font-family: roboto;
        font-weight: bold;
    }
    .loading-feed{
        background-color: #222;
        border-radius: 5px;
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: center;

        img{
            animation: rotating 2s linear infinite;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/index.vue